module.exports = __webpack_public_path__ + "static/img/gjfw.ba829ff2.png";